import { render, staticRenderFns } from "./videoItem.vue?vue&type=template&id=e54abaea&scoped=true&"
import script from "./videoItem.vue?vue&type=script&lang=js&"
export * from "./videoItem.vue?vue&type=script&lang=js&"
import style0 from "./videoItem.vue?vue&type=style&index=0&id=e54abaea&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54abaea",
  null
  
)

export default component.exports